import { render } from "./CGZModels.vue?vue&type=template&id=0f2421d8&scoped=true"
import script from "./CGZModels.vue?vue&type=script&lang=js"
export * from "./CGZModels.vue?vue&type=script&lang=js"

import "./CGZModels.vue?vue&type=style&index=0&id=0f2421d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2421d8"]])

export default __exports__